export function formatUserBadgeName(user) {
  const rawName = String(user?.name || '').trim();
  if (rawName) {
    const parts = rawName.split(/\s+/).filter(Boolean);
    if (parts.length <= 1) return rawName;
    const [firstName, ...surnames] = parts;
    const surnameInitials = surnames.map((part) => `${part.charAt(0).toUpperCase()}.`).join('');
    return `${firstName} ${surnameInitials}`.trim();
  }

  return String(user?.username || user?.email || 'Usuario').trim();
}
